export default __webpack_public_path__ + "media/images/temporary/how-we-grow-24d21c3bac9a456152c8a80e8ece0d5d.jpg";